"use strict";
import ReactUtils from "../../react_utils";
let bem = ReactUtils.makeBem("document-browser");
export default React.createClass({
  propTypes: {
    tmsObjects: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    tmsObjectDetailsFunction: React.PropTypes.func.isRequired,
    label: React.PropTypes.string.isRequired
  },
  explicitHeightStyle: function() {
    if (this.props.tmsObjects.length > 5) {
      return { height: 185 };
    } else {
      return {};
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__assign-documents-selector"), style: this.explicitHeightStyle() }, this.props.label, _.map(this.props.tmsObjects, this.props.tmsObjectDetailsFunction));
  }
});
